import ShopDTO from "@/dto/shop/ShopDTO";
import { Alert } from "antd";
import React from "react";
import moment from "moment";
import ShopTypeNameMap from "@/map/ShopTypeNameMap";
import ShopType from "@/enum/ShopType";
import { NotPlatformShopTypes } from "@/utils/ShopUtils";

interface NewShopAlertProps {
    shop: ShopDTO;
}

const link = "https://qw15p3s8hv.feishu.cn/wiki/wikcnn6brdvk5nG1o1nD3vKfZ4g";

const NewShopAlert: React.FC<NewShopAlertProps> = function ({ shop }) {
    const isOverTime = moment().isAfter(moment(shop.dateCreated).add(2, "d"));

    if (isOverTime || [...NotPlatformShopTypes, ShopType.INDEPENDENT_MANUAL].includes(shop.type)) return null;

    let tip = (
        <span>
            {ShopTypeNameMap[shop.type]}
            店铺仅同步15天内的待发货订单，如需同步15天前的历史订单请按下单时间同步
            <a href={link} target="_blank">
                （查看教程）
            </a>
        </span>
    );

    if (shop.type === ShopType.TAOBAO || shop.type === ShopType.KWAI || shop.type === ShopType.DOUDIAN) {
        tip = (
            <span>
                {ShopTypeNameMap[shop.type]}新店铺仅同步30天内的待发货订单，如需同步30天前的历史订单请按下单时间同
                <a href={link} target="_blank">
                    （查看教程）
                </a>
            </span>
        );
    }

    if (shop.type === ShopType.PINDUODUO || shop.type === ShopType.PDD_FDS || shop.type === ShopType.PDD_FULFILLMENT) {
        tip = (
            <span>
                {ShopTypeNameMap[shop.type]}新店铺仅同步5天内的待发货订单，如有5天前的待发货订单请按下单时间同步
                <a href={link} target="_blank">
                    （查看教程）
                </a>
                ，拼多多无法同步历史已发货订单
            </span>
        );
    }

    if (shop.type === ShopType.DOUDIAN_IOP || shop.type === ShopType.DOUDIAN_SUPPLIER) {
        tip = (
            <span>
                {ShopTypeNameMap[shop.type]}新店铺仅同步5天内的待发货订单，如有5天前的待发货订单请按下单时间同步
                <a href={link} target="_blank">
                    （查看教程）
                </a>
            </span>
        );
    }

    if (shop.type === ShopType.XIAOHONGSHU) {
        tip = (
            <span>
                {ShopTypeNameMap[shop.type]}新店铺仅同步7天内的待发货订单，如有7天前的待发货订单请按下单时间同步
                <a href={link} target="_blank">
                    （查看教程）
                </a>
            </span>
        );
    }

    if (shop.type === ShopType.KWAI_DROPSHIP) {
        tip = (
            <span>
                {ShopTypeNameMap[shop.type]}新店铺仅同步5天内的待发货订单，如有5天前的待发货订单请按下单时间同步
                <a href={link} target="_blank">
                    （查看教程）
                </a>
            </span>
        );
    }

    return <Alert title={<span>{tip}</span>} className="mb10" type="warning" />;
};

export default React.memo(NewShopAlert);
